import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "ef-subscriptions",
  ref: "myRef"
}
const _hoisted_2 = { class: "ef-line" }
const _hoisted_3 = { class: "ef-line" }
const _hoisted_4 = { class: "ef-subscriptions__search" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search" }, null, -1)

import {computed, ComputedRef, onMounted, ref} from "vue";
import Header from '@/components/Header.vue';
import Input from '@/components/Input.vue';
import Table from '@/components/Table.vue';
import {storeTraining} from "@/stores/training";


//STORE user

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const _storeTrainings = storeTraining();

const searchTerm = ref('');

const subscriptionsToDisplay: ComputedRef<Array<any>> = computed(() => {
  if (loading.value) {
    return [{ id: "0", fields: [{title: 'title', value: 'value'},{title: 'title', value: 'value'}, {type: 'icon', title: 'title', value: 'value'}], actions: [{ icon: 'fa-solid fa-pen', text: 'Editer', action: 'edit' }] }];
  } else {
    let result = subscriptions.value;
    //FILTER
    if (searchTerm.value !== '') {
      result = result.filter((subscription: any) => subscription.training.title.includes(searchTerm.value));
    }
    //BUILD ITEM_TABLE
    return result.map((item: any) => {
      let actions = [
        { icon: 'fa-solid fa-eye', text: 'Voir', action: 'view' },
      ];
      let icons = [];
      item.isOnline ? icons.push({icon: 'fa-solid fa-globe', text: ''}) : icons.push({icon: '', text: ''});
      item.isLocal ? icons.push({icon: 'fa-solid fa-location-dot', text: ''}) : icons.push({icon: '', text: ''});
      if (item.state === 'Refuted' || (item.state === 'WaitingForSignature' && !getRemainingTime(item.creationDate))) icons.push({icon: 'fa-regular fa-circle-xmark', text: ''});
      else if (item.state === 'WaitingForSignature') icons.push({icon: 'fa-regular fa-clock', text: getRemainingTime(item.creationDate)});
      else if (item.state === 'Validated') icons.push({icon: 'fa-regular fa-circle-check', text: ''});
      const fields = [
        { title: 'Formation', value: item.training.title },
        { title: 'Collaborateur', value: item.user.firstname + ' ' + item.user.lastname },
        { type: 'icons', icons: icons},
      ]
      return { id: item.id, fields: fields, actions: actions };
    });
  }
});

const time = ref(new Date());

const getRemainingTime = ((date:string) => {
  const startDate:any = new Date(date);
  const exDate = startDate.setHours(startDate.getHours() + 1);
  // Find the distance between now and the count down date
  let distance = exDate - time.value.getTime();
  // Time calculations for days, hours, minutes and seconds
  let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  let seconds = Math.floor((distance % (1000 * 60)) / 1000);
  if (seconds < 0) return false;
  return hours + " : "+ minutes + " : " + seconds;
});

const loading = ref(true);
const subscriptions = ref<Array<any>>([]);

onMounted(() => {
  setInterval(function () {
    time.value = new Date();
  }, 1000)
  _storeTrainings.getAllTrainingSubscriptions(0, 0).then((response) => {
    response.forEach((subscription: any) => {
      subscription.users.forEach((user: any) => {
        subscriptions.value.push({ id: subscription.id, state: subscription.state, training: subscription.training, user: user, isLocal: subscription.hasPhysicalModule, isOnline: subscription.hasOnlineModule, creationDate: subscription.creationDate });
      });
    });
    loading.value = false;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Header, {
        icone: "fa-solid fa-list-check",
        title: "Inscriptions"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(Input, {
          type: "text",
          placeholder: "Rechercher une inscription ...",
          modelValue: searchTerm.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event))
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createVNode(Table, {
      items: _unref(subscriptionsToDisplay),
      loading: loading.value,
      onView: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(`/subscriptions/${$event}`)))
    }, null, 8, ["items", "loading"])
  ], 512))
}
}

})